<template>
  <v-flex>
    <v-checkbox
      v-model="inputValue"
      :name="schema.fullKey"
      :disabled="schema.disabled"
      :readonly="schema.readonly"
      :required="schema.required"
      :rules="schema.rules"
      :label="schema.label"
      @input="emitInput()"
      @change="emitInput()"
    >
      <v-tooltip
        v-if="schema.description && schema.description.length > 0"
        slot="append"
        left
      >
        <v-icon slot="activator">info</v-icon>
        <div class="vjsf-tooltip" v-html="schema.description"></div>
      </v-tooltip>
    </v-checkbox>
  </v-flex>
</template>
<script>
export default {
  name: 'RDCheckBoxWidget',
  props: {
    schema: {
      type: Object,
      required: true
    },
    value: {
      type: Boolean,
      required: false
    }
  },
  data() {
    return {
      inputValue: this.value
    }
  },
  created() {
    if (this.schema.hide) {
      this.$emit('hide', this.schema.hide, this.inputValue)
    }
    if (this.schema.show) {
      this.$emit('show', this.schema.show, this.inputValue)
    }
  },
  methods: {
    emitInput: function() {
      this.$emit('inputChange', this.inputValue)
      this.$emit('input', this.inputValue)
      if (this.schema.hide != null) {
        this.$emit('hide', this.schema.hide, this.inputValue)
      }
      if (this.schema.show != null) {
        this.$emit('show', this.schema.show, this.inputValue)
      }
    }
  }
}
</script>
